var _path;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

var SvgEye = function SvgEye(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 5c-4.504 0-8.361 2.74-9.928 6.626a1 1 0 0 0 0 .748C3.64 16.26 7.497 19 12 19c4.503 0 8.361-2.74 9.927-6.626a1 1 0 0 0 0-.748C20.361 7.74 16.503 5 12 5zm0 12c-3.53 0-6.555-2.06-7.911-5C5.445 9.06 8.469 7 12 7c3.53 0 6.555 2.06 7.911 5-1.356 2.94-4.38 5-7.911 5zm4-5a4 4 0 1 1-2.822-3.824 2 2 0 1 0 2.646 2.646c.114.373.176.768.176 1.178z"
  })));
};

export default SvgEye;